export default __webpack_public_path__ + "static/media/menu.a23a354a.jpg";